import {call, put, all, takeLatest, select} from "redux-saga/effects";
import {Api} from "../api";
import * as boardsActions from '../actions/boards'
import {BOARD_TICKETS} from "../constants";
import * as authActions from "../actions/auth";
import {t} from "i18next";
import {saveFile} from "../helpers";

function* getBoardsFilterLookups(action) {
  try {
    const res = yield call(Api.boards.getBoardsFilterLookups, action.payload);
    yield put({type: boardsActions.GET_BOARDS_FILTER_LOOKUP_SUCCESS, payload: res.data?.data});
  } catch (err) {
    yield put({ type: boardsActions.GET_BOARDS_FILTER_LOOKUP_FAIL, payload: { error: err.message } });
    if (err?.response?.status === 401) yield put({ type: authActions.AUTH_LOGOUT_REQUEST });
  }
}

function* getBoardsTickets(action) {
  try {
    const res = yield call(Api.boards.getBoardTickets, action.payload);
    const currentBoard = yield select(state => state.boards.currentBoard);
    const newData = {...BOARD_TICKETS[currentBoard]};
    res.data?.data.tickets_data.forEach(item => {
      if(newData[item.Status]) newData[item.Status] = [...newData[item.Status], item]
    });
    yield put({
      type: boardsActions.GET_BOARDS_TICKETS_SUCCESS,
      payload: newData, total_tickets: res.data.data.total_tickets, people_data: res.data.data.people_data
    });
  } catch (err) {
    yield put({ type: boardsActions.GET_BOARDS_TICKETS_FAIL, payload: { error: err.message } });
    if (err?.response?.status === 401) yield put({ type: authActions.AUTH_LOGOUT_REQUEST });
  }
}

function* getMoreBoardsTickets(action) {
  try {
    const res = yield call(Api.boards.getBoardTickets, action.payload);
    const newTicketsState = {...yield select(state => state.boards.tickets)};
    newTicketsState[action.payload.body.Status] = [...newTicketsState[action.payload.body.Status], ...res.data?.data.tickets_data];
    yield put({type: boardsActions.GET_MORE_BOARDS_TICKETS_SUCCESS, payload: newTicketsState});
    if(action.callback) action.callback();
  } catch (err) {
    yield put({ type: boardsActions.GET_MORE_BOARDS_TICKETS_FAIL, payload: { error: err.message } });
    if (err?.response?.status === 401) yield put({ type: authActions.AUTH_LOGOUT_REQUEST });
  }
}

function* sortBoardsTickets(action) {
  try {
    const res = yield call(Api.boards.getBoardTickets, action.payload);
    const newTicketsState = {...yield select(state => state.boards.tickets)};
    newTicketsState[action.payload.body.Status] = res.data?.data.tickets_data;
    yield put({type: boardsActions.SORT_BOARDS_TICKETS_SUCCESS, payload: newTicketsState});
    if(action.callback) action.callback();
  } catch (err) {
    yield put({ type: boardsActions.SORT_BOARDS_TICKETS_FAIL, payload: { error: err.message } });
    if (err?.response?.status === 401) yield put({ type: authActions.AUTH_LOGOUT_REQUEST });
  }
}

function* createTicket(action) {
  try {
    yield call(Api.boards.createTicket, action.payload);
    action.callback(false);
    let newTicketsState = yield select(state => state.boards.tickets);
    const currentBoard = yield select(state => state.boards.currentBoard);
    yield put({type: boardsActions.GET_BOARDS_TICKETS_REQUEST, payload: {username: action.payload.username, token: action.payload.token, body: {Type: currentBoard}}})
    yield put({type: boardsActions.CREATE_TICKET_SUCCESS, payload: newTicketsState});
    // if(currentBoard === 'Tickets'){
    //   console.log(res.data, 'res.data')
    //   const newTicket = {...action.payload.body, Id: res.data.data.Id, DateCreated: new Date(), CreatedByUserUsername: action.payload.username}
    //   newTicketsState = newTicketsState['In work']
    //     ? {...newTicketsState, 'In work': [newTicket, ...newTicketsState['In work']]}
    //     : {...newTicketsState, 'In work': [newTicket]};
    //   yield put({type: boardsActions.CREATE_TICKET_SUCCESS, payload: newTicketsState});
    // }else {
    //   yield put({type: boardsActions.GET_BOARDS_TICKETS_REQUEST, payload: {username: action.payload.username, token: action.payload.token, body: {Type: currentBoard === 'Tasks' ? 'task' :'ticket'}}})
    //   yield put({type: boardsActions.CREATE_TICKET_SUCCESS, payload: newTicketsState});
    // }

  } catch (err) {
    yield put({ type: boardsActions.CREATE_TICKET_FAIL, payload: { error: err.message } });
    if (err?.response?.status === 401) yield put({ type: authActions.AUTH_LOGOUT_REQUEST });
  }
}

function* editTicket(action) {
  try {
    const res = yield call(Api.boards.createTicket, action.payload);
    if(action.callback) action.callback(false);
    const currentBoard = yield select(state => state.boards.currentBoard);
    yield put({type: boardsActions.GET_BOARDS_TICKETS_REQUEST, payload: {username: action.payload.username, token: action.payload.token, body: {Type: currentBoard}}})
    yield put({type: boardsActions.EDIT_TICKET_SUCCESS, payload: res.data});
  } catch (err) {
    yield put({ type: boardsActions.EDIT_TICKET_FAIL, payload: { error: err.message } });
    if (err?.response?.status === 401) yield put({ type: authActions.AUTH_LOGOUT_REQUEST });
  }
}

function* removeTicket(action) {
  try {
    yield call(Api.boards.removeTicket, action.payload);
    if(action.callback) action.callback();
    let newTicketsState = {...yield select(state => state.boards.tickets)};
    newTicketsState = {...newTicketsState, Created: newTicketsState.Created.filter(item => action.payload.query.id !== item.id)};
    yield put({type: boardsActions.REMOVE_TICKET_SUCCESS, payload: newTicketsState});
  } catch (err) {
    yield put({ type: boardsActions.REMOVE_TICKET_FAIL, payload: { error: err.message } });
    if (err?.response?.status === 401) yield put({ type: authActions.AUTH_LOGOUT_REQUEST });
  }
}

function* getTicketDetails(action) {
  try {
    const res = yield call(Api.boards.getTicketDetails, action.payload);
    action.callback?.(res.data?.data.Media);
    yield put({type: boardsActions.GET_TICKET_DETAILS_SUCCESS, payload: res.data?.data});
  } catch (err) {
    yield put({ type: boardsActions.GET_TICKET_DETAILS_FAIL, payload: { error: err.message } });
    if (err?.response?.status === 401) yield put({ type: authActions.AUTH_LOGOUT_REQUEST });
  }
}

function* addTicketRemarks(action) {
  try {
    const res = yield call(Api.boards.addTicketRemarks, action.payload);
    yield put({type: boardsActions.ADD_TICKET_REMARKS_SUCCESS, payload: res.data?.data});
    if(action.callback) action.callback();
  } catch (err) {
    yield put({ type: boardsActions.ADD_TICKET_REMARKS_FAIL, payload: { error: err.message } });
    if (err?.response?.status === 401) yield put({ type: authActions.AUTH_LOGOUT_REQUEST });
  }
}

function* getUserManagement(action) {
  try {
    const res = yield call(Api.boards.getUserManagement, action.payload);
    yield put({type: boardsActions.GET_USER_MANAGEMENT_SUCCESS, payload: res.data});
  } catch (err) {
    yield put({ type: boardsActions.GET_USER_MANAGEMENT_FAIL, payload: { error: err.message } });
    if (err?.response?.status === 401) yield put({ type: authActions.AUTH_LOGOUT_REQUEST });
  }
}

function* getTicketAging(action) {
  try {
    const res = yield call(Api.boards.getTicketAging, action.payload);
    const max = Math.max(...res.data.data.slice(0, -1).map(item => item.total));
    yield put({
      type: boardsActions.GET_TICKET_AGING_SUCCESS,
      payload: {chart: res.data.data, max},
    });
  } catch (err) {
    yield put({ type: boardsActions.GET_TICKET_AGING_FAIL, payload: { error: err.message } });
    if (err?.response?.status === 401) yield put({ type: authActions.AUTH_LOGOUT_REQUEST });
  }
}

function* getTicketSummaryStages(action) {
  try {
    const res = yield call(Api.boards.getTicketSummaryStages, action.payload);
    const currentBoard = yield select(state => state.boards.currentBoard);
    const bgColors = currentBoard === 'Tasks'
      ? ['#D97245', '#01686A', '#C90606', '#EFA602', '#00AB55', '#E8E6E6', '#79A3D6']
      : ['#D97245', '#01686A', '#00AB55', '#79A3D6']
    const data = {
      labels: res.data.data.labels.map(item => t(item)),
      datasets: [{data: res.data.data.data, backgroundColor: bgColors, borderWidth: 0, dataPercentage: res.data.data.dataPercentage}],
    }
    yield put({type: boardsActions.GET_TICKET_SUMMARY_STAGES_SUCCESS, payload: {chart: data}});
  } catch (err) {
    yield put({ type: boardsActions.GET_TICKET_SUMMARY_STAGES_FAIL, payload: { error: err.message } });
    if (err?.response?.status === 401) yield put({ type: authActions.AUTH_LOGOUT_REQUEST });
  }
}

function* getTicketSummaryAging(action) {
  try {
    const res = yield call(Api.boards.getTicketSummaryAging, action.payload);
    const data = {
      labels: ['< 3 Days', '< 1 Week', '< 1 Month', '< 3 Months', '> 3 Months'],
      datasets: [
        {
          data: res.data.data.data,
          backgroundColor: ['#00AB55', '#D97245', '#01686A', '#EFA602', '#C90606'],
          borderWidth: 0,
          dataPercentage: res.data.data.dataPercentage
        },
      ],
    }
    yield put({type: boardsActions.GET_TICKET_SUMMARY_AGING_SUCCESS, payload: {chart: data}});
  } catch (err) {
    yield put({ type: boardsActions.GET_TICKET_SUMMARY_AGING_FAIL, payload: { error: err.message } });
    if (err?.response?.status === 401) yield put({ type: authActions.AUTH_LOGOUT_REQUEST });
  }
}

function* exportTicketList(action) {
  try {
    const res = yield call(Api.boards.exportTicketList, action.payload);
    saveFile(res);
    yield put({type: boardsActions.EXPORT_TICKETS_LIST_SUCCESS, payload: res});
  } catch (err) {
    yield put({ type: boardsActions.EXPORT_TICKETS_LIST_FAIL, payload: { error: err.message } });
    if (err?.response?.status === 401) yield put({ type: authActions.AUTH_LOGOUT_REQUEST });
  }
}

function* exportTicketLog(action) {
  try {
    const res = yield call(Api.boards.exportTicketLog, action.payload);
    saveFile(res);
    yield put({type: boardsActions.EXPORT_TICKETS_LOG_SUCCESS, payload: res});
  } catch (err) {
    yield put({ type: boardsActions.EXPORT_TICKETS_LOG_FAIL, payload: { error: err.message } });
    if (err?.response?.status === 401) yield put({ type: authActions.AUTH_LOGOUT_REQUEST });
  }
}

function* editTicketRemarks(action) {
  try {
    yield call(Api.boards.addTicketRemarks, action.payload);
    yield put({type: boardsActions.EDIT_TICKET_REMARKS_SUCCESS, payload: action.payload.remarks});
    if(action.callback) action.callback();
  } catch (err) {
    yield put({ type: boardsActions.EDIT_TICKET_REMARKS_FAIL, payload: { error: err.message } });
    if (err?.response?.status === 401) yield put({ type: authActions.AUTH_LOGOUT_REQUEST });
  }
}




export default all([
  takeLatest(boardsActions.GET_BOARDS_FILTER_LOOKUP_REQUEST, getBoardsFilterLookups),
  takeLatest(boardsActions.GET_BOARDS_TICKETS_REQUEST, getBoardsTickets),
  takeLatest(boardsActions.GET_MORE_BOARDS_TICKETS_REQUEST, getMoreBoardsTickets),
  takeLatest(boardsActions.SORT_BOARDS_TICKETS_REQUEST, sortBoardsTickets),
  takeLatest(boardsActions.CREATE_TICKET_REQUEST, createTicket),
  takeLatest(boardsActions.EDIT_TICKET_REQUEST, editTicket),
  takeLatest(boardsActions.REMOVE_TICKET_REQUEST, removeTicket),
  takeLatest(boardsActions.GET_TICKET_DETAILS_REQUEST, getTicketDetails),
  takeLatest(boardsActions.ADD_TICKET_REMARKS_REQUEST, addTicketRemarks),
  takeLatest(boardsActions.GET_USER_MANAGEMENT_REQUEST, getUserManagement),
  takeLatest(boardsActions.GET_TICKET_AGING_REQUEST, getTicketAging),
  takeLatest(boardsActions.GET_TICKET_SUMMARY_STAGES_REQUEST, getTicketSummaryStages),
  takeLatest(boardsActions.GET_TICKET_SUMMARY_AGING_REQUEST, getTicketSummaryAging),
  takeLatest(boardsActions.EXPORT_TICKETS_LIST_REQUEST, exportTicketList),
  takeLatest(boardsActions.EXPORT_TICKETS_LOG_REQUEST, exportTicketLog),
  takeLatest(boardsActions.EDIT_TICKET_REMARKS_REQUEST, editTicketRemarks),
])
